import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chronicle",
  "use": "icon-chronicle-usage",
  "viewBox": "0 0 39.868 44.298",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 39.868 44.298\" id=\"icon-chronicle\">\r\n  <path id=\"icon-chronicle_icon\" d=\"M165.668,85.333a2.2,2.2,0,0,1,2.2,2.2v39.9a2.215,2.215,0,0,1-2.2,2.2H130.2a2.2,2.2,0,0,1-2.2-2.2v-39.9a2.215,2.215,0,0,1,2.2-2.2Zm-14.042,17.719H133.906v4.43h17.719Zm0-8.86H133.906v4.43h17.719Zm.65,24.633-5.484-5.481-3.13,3.13,8.614,8.617,12.527-12.53-3.13-3.13-9.4,9.391v.006Z\" transform=\"translate(-128 -85.333)\" fill=\"#fff\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol